<template>
    <div ref="parent" class="awdb" :class="awardLevel" data-active="false">
        <Icon :name="`award-${type}`" />
    </div>
</template>

<script>
import Icon from "@c/Icon.vue"
export default {
    components: {
        Icon,
    },
    data() {
        return {

        }
    },
    props: {
        active: Boolean,
        siloData: Object,
        type: String,
    },
    computed: {
        trackedCount() {
            let tracked = null;
            if (this.type === "practice") {
                tracked = this.siloData.user.stats.practices_completed;
            }
            if (this.type === "tracking") {
                tracked = JSON.parse(this.siloData.user.stats.checkins_full).length;
            }
            return tracked !== null ? tracked : 0;
        },
        awardLevel() {
            let returned = "awdb--none";

            // Practice awards
            if (this.type==="practice") {
                if (this.trackedCount >= 4) {
                    returned = "awdb--bronze";
                    if (this.trackedCount >= 8) {
                        returned = "awdb--silver";
                        if (this.trackedCount >= 12) {
                            returned = "awdb--gold";
                            if (this.trackedCount >= 16) {
                                returned = "awdb--diamond";
                            }
                        }
                    }
                }
            }

            // Tracking awards
            if (this.type==="tracking") {
                if (this.trackedCount >= 10) {
                    returned = "awdb--bronze";
                    if (this.trackedCount >= 15) {
                        returned = "awdb--silver";
                        if (this.trackedCount >= 20) {
                            returned = "awdb--gold";
                            if (this.trackedCount >= 25) {
                                returned = "awdb--diamond";
                            }
                        }
                    }
                }
            }

            return returned;
        }
    },
    mounted() {
        //this.onActive();
    },
    watch: {
        /*
        active() {
            if (this.active === true) {
                this.onActive();
            } else {
                this.$refs.parent.dataset.active = false;
            }
        }
            */
    },
    methods: {
        /*
        onActive() {
            let timeroll = Math.floor(Math.random() * 500) + 400;
            setTimeout(() => {
                this.$refs.parent.dataset.active = true;
            }, timeroll);
        }
        */
    }
}

</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

.awdb {
    transition: all 0.15;
    > * {
        width: 100%;
        height: auto;
    }
    &--silver {
        circle {
            fill: #E9F3F8;
        }
        path {
            fill: #BCC6CC;
        }
    }

    &--gold {
        circle {
            fill: #FCEFB9;
        }
        path {
            fill: #FDD017;
        }
    }

    &--diamond {
        circle {
            fill: #D3E1F5;
        }
        path {
            fill: #88B5F9;
        }
    }

    &--none {
        opacity: 0.5;
        filter:grayscale(1);
    }
}
</style>